import produce from 'immer';
import { TERMS_REQUEST, TERMS_SUCCESS, TERMS_FAILURE, TERM_LATEST_REQUEST, TERM_LATEST_SUCCESS, TERM_LATEST_FAILURE, POLICIES_REQUEST, POLICIES_SUCCESS, POLICIES_FAILURE, POLICY_LATEST_REQUEST, POLICY_LATEST_SUCCESS, POLICY_LATEST_FAILURE, REQUEST_DATA_FAILURE, REQUEST_DATA_REQUEST, REQUEST_DATA_SUCCESS, } from './constants';
export var initialState = {
    loading: false,
    error: '',
    terms: [],
    latestTerm: {},
    policies: [],
    latestPolicy: {},
};
function dataAndPrivacyReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        switch (action.type) {
            case TERMS_REQUEST:
                state.loading = true;
                state.error = '';
                break;
            case TERMS_SUCCESS:
                state.loading = true;
                state.terms = action.terms;
                state.error = '';
                break;
            case TERMS_FAILURE:
                state.loading = true;
                state.error = '';
                break;
            case TERM_LATEST_REQUEST:
                state.loading = true;
                state.error = '';
                break;
            case TERM_LATEST_SUCCESS:
                state.loading = true;
                state.latestTerm = action.latestTerm;
                state.error = '';
                break;
            case TERM_LATEST_FAILURE:
                state.loading = true;
                state.error = '';
                break;
            case POLICIES_REQUEST:
                state.loading = true;
                state.error = '';
                break;
            case POLICIES_SUCCESS:
                state.loading = true;
                state.policies = action.policies;
                state.error = '';
                break;
            case POLICIES_FAILURE:
                state.loading = true;
                state.error = '';
                break;
            case POLICY_LATEST_REQUEST:
                state.loading = true;
                state.error = '';
                break;
            case POLICY_LATEST_SUCCESS:
                state.loading = true;
                state.latestPolicy = action.latestPolicy;
                state.error = '';
                break;
            case POLICY_LATEST_FAILURE:
                state.loading = true;
                state.error = '';
                break;
            case REQUEST_DATA_REQUEST:
                state.loading = true;
                state.error = '';
                break;
            case REQUEST_DATA_SUCCESS:
                state.loading = false;
                state.error = '';
                break;
            case REQUEST_DATA_FAILURE:
                state.loading = false;
                state.error = action.err;
                break;
            default:
                break;
        }
    });
}
export default dataAndPrivacyReducer;
